<div id="linq-sockets-notifications" class="linqsockets-notifications">
  <div (click)="toggleOpen()" class="linqsockets-notifications-bell">
    <div
      [textContent]="notifications.length"
      [hidden]="notifications.length == 0"
      class="linqsockets-badge linqsockets-notifications-bell-badge"
    ></div>

    <div class="linqsockets-notifications-bell-icon">
      <!-- can't import as file because currentColor doesn't work -->
      <!-- can't import as string because inline loaders don't work -->
      <svg
        aria-hidden="true"
        focusable="false"
        class="linqsockets-notifications-bell-icon-svg"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
      >
        <path
          fill="currentColor"
          d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
        ></path>
      </svg>
    </div>
  </div>

  <div class="linqsockets-notifications-dropdown" [hidden]="!isOpen">
    <div
      *ngFor="let notification of notifications"
      (click)="notificationClick(notification, $event)"
      data-linqsockets-notification
      class="linqsockets-notification"
    >
      <div class="linqsockets-notification-header">
        <div
          [textContent]="notification.Message.Title"
          class="linqsockets-notification-title linqsockets-ellipsis"
        ></div>
        <div
          (click)="dismissNotification(notification)"
          class="linqsockets-notification-dismiss"
        ></div>
      </div>

      <p
        [textContent]="notification.Message.Description"
        class="linqsockets-notification-content"
      ></p>
      <div
        [textContent]="notification.receivedAt | date:'short'"
        class="linqsockets-notification-timestamp"
      ></div>
    </div>

    <div
      *ngIf="notifications.length > 0; else noNotifications"
      (click)="dismissAllNotifications()"
      class="linqsockets-notifications-drawer"
      [ngClass]="{'linqsockets-notifications-dismissall': notifications.length > 0}"
    >
      Dismiss all notifications
    </div>

    <ng-template #noNotifications>
      No notifications.
    </ng-template>
  </div>
</div>
